import React, { Component } from 'react';

import Alert from 'react-bootstrap/Alert';

import * as constants from '../../config/constants/AppConstants';

const AUTO_HIDE_DELAY = constants.AppSettings.AUTO_HIDE_DELAY;

const UI_SIZE = constants.AppSettings.UI_SIZE;
class CommonAlert extends Component {

    constructor(props) {
        super(props);
        this.state = { 
            fadingOut: false, 
            autoHide: false
        };        
    }

    componentDidUpdate = (prevProps) => {
        const { alert, callback } = this.props;
    
        if (alert.show && !prevProps.alert.show) {
            const autoHide = constants.AlertProps[this.props.alert.mode]?.autoHide ?? false;
            
            if (autoHide) { 
                setTimeout(() => {
                    this.setState(
                        { fadingOut: true, autoHide: autoHide },
                        () => {
                            setTimeout(() => {
                                this.setState({ fadingOut: false });
                                if (callback) {
                                    callback({ autoHide: true });
                                }
                            }, 800);
                        }
                    );
                }, AUTO_HIDE_DELAY);
            }
        }
    }
    
    render = () => {
        
        let { alert, size = "md" } = this.props;

        let { mode, show } = alert;
    
        let AlertProps = constants.AlertProps[mode] || {};
            
        let {variant = 'primary', key = 'dark', icon = '', title = '', message = '', dismiss = false } = AlertProps;

        const { fadingOut } = this.state;

        if (!show) return null; 

        return (
            <Alert 
                key={key} 
                variant={variant} 
                dismissible={dismiss}
                onClose={dismiss ? () => this.props.callback({autoHide: true}) : undefined}
                className={`custom-alert ${fadingOut ? "alert-fade-out" : ""} ${size === 'sm' ? 'custom-alert-sm' : ''}`}
                style={{marginBottom: '0px'}}
            >
                <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
                    {icon && (
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <i className={icon} />
                        </div>
                    )}

                    <div style={{ width: "100%", marginTop: '-2px' }}>
                        <span className={`title-${UI_SIZE}`}>{title}</span>

                        {message && (
                            <>
                                <hr style={{ margin: "8px 0", borderTop: "1px solid rgba(0, 0, 0, 0.1)", width: "100%" }} />
                                <span className="title-xs text-muted">{message}</span>
                            </>
                        )}
                    </div>
                </div>
            </Alert>
        )

    }
}

export default CommonAlert;